export default __webpack_public_path__ + "static/media/FAC1.aeb251bf.jpg";